module.exports = __webpack_public_path__ + "img/penta5_icon.1c7d24cf.png";